import { IPublicClientApplication } from '@azure/msal-browser';
import { dvList, dvCreate, dvDelete } from '../api/dataverseClient';
import { TimeEntry } from '../types';

const FIELDS = [
  'dagrun_pm_timeentryid','dagrun_pm_name','dagrun_pm_userid','dagrun_pm_username',
  'dagrun_pm_logdate','dagrun_pm_hours','dagrun_pm_isbillable','dagrun_pm_notes',
  'createdon','_dagrun_pm_projectid_value','_dagrun_pm_taskid_value',
];

export async function getProjectTimeEntries(pca: IPublicClientApplication, projectId: string): Promise<TimeEntry[]> {
  return dvList<TimeEntry>(pca, 'dagrun_pm_timeentries', {
    select: FIELDS,
    filter: `_dagrun_pm_projectid_value eq ${projectId}`,
    orderby: 'dagrun_pm_logdate desc,createdon desc',
    top: 500,
  });
}

export interface LogTimeInput {
  projectId: string;
  taskId?: string | null;
  userId: string;
  userName: string;
  logDate: string;
  hours: number;
  isBillable: boolean;
  notes?: string | null;
}

export async function logTimeEntry(pca: IPublicClientApplication, input: LogTimeInput): Promise<string> {
  const data: Record<string, unknown> = {
    dagrun_pm_name: input.notes?.trim() || `Time entry ${input.logDate}`,
    dagrun_pm_logdate: input.logDate,
    dagrun_pm_hours: input.hours,
    dagrun_pm_isbillable: input.isBillable,
    dagrun_pm_userid: input.userId,
    dagrun_pm_username: input.userName,
    'dagrun_pm_projectid@odata.bind': `/dagrun_pm_projects(${input.projectId})`,
  };
  if (input.notes) data.dagrun_pm_notes = input.notes;
  if (input.taskId) data['dagrun_pm_taskid@odata.bind'] = `/dagrun_pm_tasks(${input.taskId})`;
  return dvCreate(pca, 'dagrun_pm_timeentries', data);
}

// Back-compat: keep the old signature so any callers still compile.
export async function logTime(
  pca: IPublicClientApplication,
  projectId: string,
  taskId: string | null,
  logDate: string,
  hours: number,
  isBillable: boolean,
  notes: string,
): Promise<string> {
  return logTimeEntry(pca, {
    projectId, taskId, logDate, hours, isBillable, notes,
    userId: '', userName: '',
  });
}

export async function deleteTimeEntry(pca: IPublicClientApplication, id: string): Promise<void> {
  return dvDelete(pca, 'dagrun_pm_timeentries', id);
}
